export default {
      id: "delete-new-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#delete-new",
      toString: function () {
        return this.url;
      }
    }